const MOIS_OPTIONS = [
  { value: 1, label: 'Janvier' },
  { value: 2, label: 'Février' },
  { value: 3, label: 'Mars' },
  { value: 4, label: 'Avril' },
  { value: 5, label: 'Mai' },
  { value: 6, label: 'Juin' },
  { value: 7, label: 'Juillet' },
  { value: 8, label: 'Août' },
  { value: 9, label: 'Septembre' },
  { value: 10, label: 'Octobre' },
  { value: 11, label: 'Novembre' },
  { value: 12, label: 'Décembre' },
];

export const getDefaultBilanPeriod = () => {
  const now = new Date();
  return {
    periode_debut_annee: now.getFullYear(),
    periode_debut_mois: 1,
    periode_fin_annee: now.getFullYear(),
    periode_fin_mois: now.getMonth() + 1,
  };
};

export { MOIS_OPTIONS };
